<script setup lang="ts">
import type { RouteLocation } from "#vue-router";
import type { IRTSidePanelImpact } from "./IRTSidePanelImpact";
import { formatCountSuffix } from "@frontiers-vue3/public-pages";
import { scrollToItem } from "~/helpers";
import { useEnvironmentConfigStore } from "~/stores/environmentConfig";
import { numberCommaSeparator } from "~/helpers";

const props = defineProps<IRTSidePanelImpact>();
const { minimumRtDownloadsCount } = useEnvironmentConfigStore().getConfig();

const impactNumbers = computed((): Record<string, string> => {
  const impactNumbers: Record<string, string> = {};
  for (const index in props.impactNumbers) {
    const impactNumberValue = props.impactNumbers[index];
    if (impactNumberValue > minimumRtDownloadsCount) {
      const formated = formatCountSuffix(impactNumberValue);
      impactNumbers[index] = `${formated.value}${formated.suffix || ""}`;
    }
  }

  return impactNumbers;
});

const viewImpactLink = computed((): string | RouteLocation => {
  const { rtId, rtSlug } = useRoute().params;
  return `/research-topics/${rtId}/${rtSlug}/impact`;
});

const scrollToMainTabs = () => {
  setTimeout(() => scrollToItem("MainTabs", 56), 250);
};
</script>

<template>
  <div class="RtSidePanel__Section">
    <p class="RtSidePanel__Section__Title">Impact</p>
    <ul class="RtSidePanel__Section__ImpactNumbers">
      <li v-for="(value, key, index) in impactNumbers" :key="index">
        <span class="value">{{ numberCommaSeparator(value) }}</span>
        <span class="title">{{ key }}</span>
      </li>
    </ul>
    <NuxtLink
      :to="viewImpactLink"
      class="RtSidePanel__Section__Link"
      @click="scrollToMainTabs">
      <span>View impact</span>
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.RtSidePanel__Section {
  border-top: 1px solid $grey40;
}

.RtSidePanel__Section__ImpactNumbers {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 28px;
  margin-top: 16px;
  color: $black;

  li {
    display: flex;
    flex-direction: column;

    & .value {
      @include f-20;
      font-weight: 600;
    }

    & .title {
      @include f-14-300;
    }
  }
}
.RtSidePanel__Section__Link {
  font-family: "MuseoSans";
  @include f-16;
  color: var(--maincolor50);
  font-weight: 600;

  &:hover {
    color: var(--maincolor70);
    span {
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 2px;
    }
  }

  &::after {
    font-family: $fontIcon;
    content: "\e90e";
    font-size: 16px;
    vertical-align: middle;
  }
}
</style>
